/** The earliest date a field accepts, given the whole record, or undefined for no limit. */
export type FieldMinDate = (record: Record<string, unknown>) => string | Date | undefined;

/** Limits a date field can name, addressed by key so page config stays serialisable. */
export const fieldMinDates: Record<string, FieldMinDate> = {};

/** Filled from each record definition's own limits, by recordDefinitions. */
export function registerFieldMinDates(limits: Record<string, FieldMinDate> | undefined) {
  Object.assign(fieldMinDates, limits);
}

/** Undefined for an unknown name, so an older build offers every date. */
export function getFieldMinDate(name: string | undefined) {
  return name ? fieldMinDates[name] : undefined;
}
